var _circle, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBellInactive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.7192,
    cy: 11.7192,
    r: 10.7192,
    fill: "#EB4983"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3405 3.46783V5.04431H14.0723V3.46783H20.3405ZM18.0669 0.986914V7.64456H16.3522V0.986914H18.0669Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6179 10.7855C14.6179 7.75831 12.9896 6.72857 11.4667 6.49905C11.4667 6.48354 11.4698 6.46803 11.4698 6.44942C11.4698 6.06792 11.1317 5.76396 10.7192 5.76396C10.3067 5.76396 9.98101 6.06792 9.98101 6.44942C9.98101 6.46803 9.98101 6.48354 9.98411 6.49905C8.45811 6.73167 6.82045 7.76451 6.82045 10.7917C6.82045 14.3214 5.94269 14.6998 4.76407 15.6923H16.6743C15.5019 14.6967 14.6179 14.3152 14.6179 10.7855Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7253 17.6744C11.5566 17.6744 12.2389 17.0571 12.3289 16.3407H9.1218C9.20864 17.0571 9.8941 17.6744 10.7253 17.6744Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellInactive);
export default __webpack_public_path__ + "static/media/BellInactive.a15f5576976b3eee83fa158ca68cc045.svg";
export { ForwardRef as ReactComponent };